export const FIELDS_COUNT = {
  ONE_FIELD: 1,
  TWO_FIELDS: 2,
  THREE_FIELDS: 3
}
